import React, {Component} from 'react';
import toastr from "toastr";
import CustomizeShortLinkModal from "../modals/CustomizeShortLinkModal";
import {Callout, Intent, PopoverInteractionKind, Position, Tooltip} from '@blueprintjs/core'
import {Switch as BlueprintSwitch} from '@blueprintjs/core'

import http from "../../services/httpService";

import {build} from "url-utm-params";
import {Route, Switch} from 'react-router-dom';

import {
    FacebookShareButton,
    LinkedinShareButton,
    RedditShareButton,
    TwitterShareButton,
    VKShareButton,
    FacebookIcon,
    TwitterIcon,
    LinkedinIcon,
    RedditIcon,
    VKIcon
} from "react-share";
import {default as authService, getCurrentUserId, getJwt} from "../../services/authService";
import URLShortenerPerformance from "./URLShortenerPerformance";
import UpsellModal from "../modals/UpsellModal";
import UpsellModalTailwind from "../modals/UpsellModalTailwind";

class UrlShortener extends Component {
    constructor(props) {
        super(props);

        this.state = {

            title: this.props.location && this.props.location.state && this.props.location.state.title !== undefined ? this.props.location.state.title : '',

            longUrl: this.props.location && this.props.location.state && this.props.location.state.longUrlUtm !== undefined ? this.props.location.state.longUrlUtm.substr(0, this.props.location.state.longUrlUtm.indexOf('?')) : '',
            longUrlUtm: this.props.location && this.props.location.state && this.props.location.state.longUrlUtm !== undefined ? this.props.location.state.longUrlUtm : '',

            utmTracking: localStorage.getItem("utmTracking") && localStorage.getItem("utmTracking").length > 0 ? localStorage.getItem("utmTracking") === 'true' : true,
            utmCampaign: localStorage.getItem("utmCampaign") && localStorage.getItem("utmCampaign").length > 0 || localStorage.getItem("utmCampaign") === '' ? localStorage.getItem("utmCampaign") : 'emitto',
            utmSource: localStorage.getItem("utmSource") && localStorage.getItem("utmSource").length > 0 || localStorage.getItem("utmSource") === '' ? localStorage.getItem("utmSource") : 'shortener',
            utmMedium: localStorage.getItem("utmMedium") && localStorage.getItem("utmMedium").length > 0 ? localStorage.getItem("utmMedium") : '',
            utmTerm: localStorage.getItem("utmTerm") && localStorage.getItem("utmTerm").length > 0 ? localStorage.getItem("utmTerm") : '',
            utmContent: localStorage.getItem("utmContent") && localStorage.getItem("utmContent").length > 0 ? localStorage.getItem("utmContent") : '',
            customName: localStorage.getItem("customName") && localStorage.getItem("customName").length > 0 ? localStorage.getItem("customName") : '',
            customValue: localStorage.getItem("customValue") && localStorage.getItem("customValue").length > 0 ? localStorage.getItem("customValue") : '',
            remember: false,
            campaignStep: 1,
            shortCode: '',
            shortenedUrl: this.props.location && this.props.location.state && this.props.location.state.shortenedUrl ? this.props.location.state.shortenedUrl : '',
            loadingPreview: false,
            previewImgUrl: '',
            previewTitle: '',
            linkUnavailable: false,
            customizeShortLinkModal: false,
            selectedSource: this.props.selectedSource, //feedsShared: this.props.feedsShared,
            selectedDomain: 'https://oo.fyi/t/',
            loading: false,
            navigation: 1,
            sourcePlan: '',
            freeMessages: '',
            upgradeModalActive: false,
            upgradeModalTitle: '',
            upgradeModalContent: '',
            modalButtonLabel: '',
            modalButtonLink: '',
            currentPlanLimitations: this.props.currentPlanLimitations,
            clipboard: 0,
            user: this.props.user
        };toastr.options = {};
    }

    handleDomainRadio = (e) => {
        this.setState({
            selectedDomain: e
        })
    }
    editShortenedUrl = (rowIndex, shownUrls) => {
        //console.log('rowIndex: ', rowIndex)
        //console.log('shownUrls: ', shownUrls)
        this.setState({
            campaignStep: 1,
            navigation: 1,
            longUrl: shownUrls[rowIndex].original_url,
            shortenedUrl: shownUrls[rowIndex].short_url,
            shortCode: shownUrls[rowIndex].short_url.split("t/").pop(),
            longUrlUtm: shownUrls[rowIndex].original_url,
            title: shownUrls[rowIndex].title
        })

        this.props.history.push('/url/shortener')
    }
    openUpgradeModal = () => {
        this.setState({
            upgradeModalTitle: "URL Shortener is not available on your current plan.", upgradeModalContent: `<p>Check out the plans and features below and choose one that suits your needs.<br>
                Our team is available from the chat if you need any assistance.</p>`, upgradeModalActive: true
        })
    }

    utmTagsUnavailableUpsellModal = () => {

        this.setState({
            upgradeModalTitle: "UTM Tracking is not available on your current plan.", upgradeModalContent: `<p>Check out the plans and features below and choose one that suits your needs.<br>
                Our team is available from the chat if you need any assistance.</p>`, upgradeModalActive: true
        })

    }
    noMessagesRemaining = () => {
        this.setState({
            upgradeModalTitle: "You're out of the URL Shortener credits!",
            upgradeModalContent: "You hit the limit for this month. To be able to shorten more links, please subscribe to bigger plan!",
            upgradeModalActive: true
        })
    }

    toggleEnableUTM = async () => {

        let utmTracking = !this.state.utmTracking;

        await this.setState({utmTracking});
        let params = {
            utm_source: this.state.utmSource,
            utm_medium: this.state.utmMedium,
            utm_campaign: this.state.utmCampaign,
            utm_content: this.state.utmContent,
            utm_term: this.state.utmTerm,

        };

        if (this.state.customName.length > 0) {
            params[this.state.customName] = this.state.customValue;
        }
        //console.log('params: ', params);


        //cleaning empty params
        Object.keys(params).map((keyName, i) => {
            if (params[keyName] === '') {
                delete params[keyName]
            }
        });


        //console.log('new params: ', params);
        let longUrlUtm = '';

        if (this.state.utmTracking === true) {
            longUrlUtm = this.state.longUrl.length > 0 ? await build(this.state.longUrl, params, false) : ''
        } else {
            longUrlUtm = this.state.longUrl.length > 0 ? await this.state.longUrl : ''
        }
        //console.log('longUrlUtm: ', longUrlUtm)

        this.setState({

            longUrlUtm
        })
    };
    switchOnChange = () => {
        //console.log('changed');
    }


    saveEditData = async () => {
        if (this.state.longUrl !== '') {
            await this.setState({
                loading: true
            })
            toastr.info('Saving in progress...');

            let URL_META = this.state.longUrlUtm;
            let n = await URL_META.startsWith('http');
            let UTM_URL = this.state.longUrlUtm;

            if (n === false) {

                UTM_URL = 'http://' + this.state.longUrlUtm;
            }
            await this.setState({

                longUrlUtm: UTM_URL
            });

            // let domainFormat = ''
            // if (this.state.selectedDomain === 'https://oo.fyi/t/') {
            //     domainFormat = 'oo'
            // } else {
            //     domainFormat = 's'
            // }
            let params = {
                user_id: getCurrentUserId(),
                project_id: this.props.selectedSource,
                code: this.state.shortCode.replace('t/', ''),
                url: this.state.longUrlUtm,
                title: this.state.title || ' ',

            };
            //console.log('editing params: ', params);
            try {
                const response = await http.post('https://oo.fyi/edit', params);
                //console.log('editing response: ', response);
                //let shortCode = response.data.replace(this.state.selectedDomain, '')

                await this.setState({
                    campaignStep: 2, // shortenedUrl: response.data,
                    // shortCode: shortCode
                    loading: false
                });

                this.getLinkData()

            } catch (e) {
                // event.preventDefault();
                await this.setState({
                    loading: false
                })
                toastr.error(e);
            }
        } else {
            toastr.error("URL field can't be empty.")
        }
    }

    saveShortCode = async (oldShortCode, shortCode, domain) => {

        shortCode = shortCode.replace(' ', '%20')
        let data = {
            "user_id": getCurrentUserId(),
            "code": oldShortCode,
            "custom_code": shortCode,
            "project_id": this.state.selectedSource,
            "custom_domain_url": domain
        };
        try {
            const result = await http.post("https://oo.fyi/edit-short", data, {
                headers: {
                    authorization: authService.getJwt()
                }
            });
            //console.log('save short code result: ', result);
            await this.setState({
                shortenedUrl: result.data.body.short_url,
                customizeShortLinkModal: false,
                shortCode: shortCode,
                selectedDomain: domain
            })
            toastr.success("Saved!")
        } catch (e) {
            toastr.error(e)
        }
    }

    componentDidMount = async () => {
        //ReactGA.pageview(window.location.pathname + window.location.search);
        // console.log('utmTracking: ', localStorage.getItem("utmTracking"))
        //console.log('history props: ', this.props.location.state.short_url)

        let firstTab = document.getElementById('shorten-url')
        if (firstTab) {
            console.log('clickFirstTab')
            firstTab.click()
        }
        let utmString = '';
        if (this.props.location && this.props.location.state && this.props.location.state.editShortUrl) {
            let data = this.props.location.state.editShortUrl;
            this.editShortenedUrl(data.rowIndex, data.shownUrls);
        }
        if (this.props.location && this.props.location.state && this.props.location.state.longUrlUtm !== undefined) {
            utmString = '?' + this.props.location.state.longUrlUtm.split('?')[1];
            // console.log('utm string: ', utmString.trim());
            // const urlParams = new URLSearchParams(utmString.trim());
            // console.log('urlParams: ', urlParams);
            //
            // const utmCampaign = urlParams.get('utmCampaign');
            // console.log('utmTracking: ', utmCampaign);

            let utmCampaign = this.getParameterByName('utm_campaign', utmString);
            let utmSource = this.getParameterByName('utm_source', utmString);
            let utmMedium = this.getParameterByName('utm_medium', utmString);
            let utmTerm = this.getParameterByName('utm_term', utmString);
            let utmContent = this.getParameterByName('utm_content', utmString);

            //custom

            // console.log('utmCampaign: ', utmCampaign);
            // console.log('utmSource: ', utmSource);
            // console.log('utmMedium: ', utmMedium);
            // console.log('utmTerm: ', utmTerm);
            // console.log('utmContent: ', utmContent);

//stripping url parameters from string to test if there is a custom parameter
            let strippingCampaign = this.removeURLParameter(this.props.location.state.longUrlUtm, 'utm_campaign');
            let strippingSource = this.removeURLParameter(strippingCampaign, 'utm_source');
            let strippingMedium = this.removeURLParameter(strippingSource, 'utm_medium');
            let strippingTerm = this.removeURLParameter(strippingMedium, 'utm_term');
            let strippingContent = this.removeURLParameter(strippingTerm, 'utm_content');
            let onlyCustom = strippingContent.split("?").pop();
            let customName = '';
            let customValue = '';
            if (onlyCustom.includes('=')) {
                //console.log('onlyCustom contains =');

                //taking everything before '='
                customName = onlyCustom.substr(0, onlyCustom.indexOf('='));
                customName = customName.replace(/%20/g, " ")
                //taking everything after '='
                customValue = onlyCustom.split("=").pop();
                customValue = customValue.replace(/%20/g, " ")
            }
            let currentPlanLimitations = this.state.currentPlanLimitations
            if (this.state.user.sources) {
                let selectedSourceFull = this.state.user.sources.data.filter(source => {
                    return source.id.toString() === this.props.selectedSource.toString()
                })

                //console.log('urlWithoutCampaign: ', onlyCustom);
                if (selectedSourceFull[0].use_custom_plan === 1 && selectedSourceFull[0].custom_plan) {
                    // console.log('hasCustomPlan')
                    currentPlanLimitations = selectedSourceFull[0].custom_plan
                }
            }

            await this.setState({
                utmCampaign: utmCampaign === null ? '' : utmCampaign,
                utmSource: utmSource === null ? '' : utmSource,
                utmMedium: utmMedium === null ? '' : utmMedium,
                utmTerm: utmTerm === null ? '' : utmTerm,
                utmContent: utmContent === null ? '' : utmContent,
                customName: customName,
                customValue: customValue,
                shortCode: this.props.location.state.shortCode,
                currentPlanLimitations
            })

        }
        if (window.location.pathname === '/url/shortener') {
            this.setState({navigation: 1})
        } else if (window.location.pathname === '/url/analytics') {
            this.setState({navigation: 2})
        } else if (window.location.pathname === '/url/settings') {
            this.setState({navigation: 3})
        }

    }


    getParameterByName = (name, url) => {
        // console.log('parameter name: ', name);
        // console.log('parameter url: ', url);

        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    };

    removeURLParameter = (url, parameter) => {
        //prefer to use l.search if you have a location/link object
        let urlparts = url.split('?');
        if (urlparts.length >= 2) {

            let prefix = encodeURIComponent(parameter) + '=';
            let pars = urlparts[1].split(/[&;]/g);

            //reverse iteration as may be destructive
            for (let i = pars.length; i-- > 0;) {
                //idiom for string.startsWith
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }

            return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
        }
        return url;
    };


    componentDidUpdate = async () => {
        //this 'if' is a mandatory thing for componentDidUpdate not to enter infinite loop

        if (this.state.selectedSource !== this.props.selectedSource) {
            // console.log('selectedSource changed to: ', this.props.selectedSource)
            let firstTab = document.getElementById('shorten-url')
            if (firstTab) {
                console.log('clickFirstTab')
                firstTab.click()
            }
            await this.setState({selectedSource: this.props.selectedSource})
            let currentPlanLimitations = {}
            if (this.state.currentPlanLimitations !== this.props.currentPlanLimitations) {
                currentPlanLimitations = this.props.currentPlanLimitations
            }

            if (this.state.user.sources) {
                let selectedSourceFull = this.state.user.sources.data.filter(source => {
                    return source.id.toString() === this.props.selectedSource.toString()
                })

                // console.log('selectedSourceFull: ', selectedSourceFull)
                if (selectedSourceFull[0].use_custom_plan === 1 && selectedSourceFull[0].custom_plan) {
                    // console.log('hasCustomPlan')
                    currentPlanLimitations = selectedSourceFull[0].custom_plan
                }
                this.setState({
                    selectedSource: this.props.selectedSource,
                    selectedSourceFull,
                    payment: selectedSourceFull[0].default_billing_details,
                    currentPlanLimitations
                })
            }


        }

        if ((window.location.pathname === '/url/shortener') && (this.state.navigation !== 1)) {
            this.setState({navigation: 1})
        } else if ((window.location.pathname === '/url/analytics') && (this.state.navigation !== 2)) {
            this.setState({navigation: 2})
        } else if ((window.location.pathname === '/url/settings') && (this.state.navigation !== 3)) {
            this.setState({navigation: 3})
        }
    }

    handleRemember = async () => {
        let remember = true;
        localStorage.setItem("utmTracking", this.state.utmTracking);
        localStorage.setItem("utmCampaign", this.state.utmCampaign);
        localStorage.setItem("utmSource", this.state.utmSource);
        localStorage.setItem("utmMedium", this.state.utmMedium);
        localStorage.setItem("utmTerm", this.state.utmTerm);
        localStorage.setItem("utmContent", this.state.utmContent);
        localStorage.setItem("utmTracking", this.state.utmTracking);
        localStorage.setItem("customName", this.state.customName);
        localStorage.setItem("customValue", this.state.customValue);
        await this.setState({
            remember
        })

        toastr.info('Saved!')
    };

    handleInput = async (e) => {
        //console.log('input id: ', e.target.id);

        //
        // if (e.target.id === 'longUrl') {
        //
        //     let URL_META = e.target.value;
        //     let n = URL_META.startsWith('http');
        //
        //     if (n === false) {
        //         URL_META = 'http://' + URL_META;
        //     }
        //     this.setState({longUrl: URL_META});
        //
        // } else {

        await this.setState({
            [e.target.id]: e.target.value
        });

        if (this.state.longUrl !== '') {
            this.handleCampaign()
        } else {
            await this.setState({
                longUrlUtm: ''
            })
        }
    };

    handleCampaign = async () => {
        let params = {
            utm_source: this.state.utmSource,
            utm_medium: this.state.utmMedium,
            utm_campaign: this.state.utmCampaign,
            utm_content: this.state.utmContent,
            utm_term: this.state.utmTerm,

        };

        if (this.state.customName.length > 0) {
            params[this.state.customName] = this.state.customValue;
        }
        //console.log('params: ', params);


        //cleaning empty params
        Object.keys(params).map((keyName, i) => {
            if (params[keyName] === '') {
                delete params[keyName]
            }
        });


        //console.log('new params: ', params);
        let longUrlUtm = '';

        if (this.state.utmTracking === true) {
            longUrlUtm = await build(this.state.longUrl, params, false)
        } else {
            longUrlUtm = await this.state.longUrl
        }
        await this.setState({
            longUrlUtm
        })
    };


    getProjectShortenedData = async () => {
        if (this.state.longUrl !== '') {
            try {
                const result = await http.get("https://short.emitto.io/project/" + this.props.selectedSource);
                //console.log("result.data.data", result);
            } catch (e) {
                toastr.error(e);
            }
        }
    };


    generateShortURL = async () => {

        if (this.state.currentPlanLimitations?.url_shortener?.enabled) {


            if (this.state.longUrl !== '') {
                toastr.info('Shortening in progress...');
                this.setState({
                    loading: true
                })
                let URL_META = await this.state.longUrl;
                let n = await URL_META.startsWith('http');
                let UTM_URL = this.state.longUrlUtm;

                if (n === false) {
                    URL_META = 'http://' + URL_META;
                    UTM_URL = 'http://' + this.state.longUrlUtm;
                }
                await this.setState({
                    longUrl: URL_META, longUrlUtm: UTM_URL
                });

                let domainFormat = ''
                if (this.state.selectedDomain === 'https://oo.fyi/t/') {
                    domainFormat = 'oo'
                } else {
                    domainFormat = 's'
                }
                let params = {
                    url: this.state.sourcePlan === 'free_plan' ? this.state.longUrl : this.state.utmTracking ? this.state.longUrlUtm : this.state.longUrl,
                    title: this.state.title || ' ',
                    project_id: this.props.selectedSource,
                    user_id: getCurrentUserId(),
                    domain_format: domainFormat
                };

                try {
                    const response = await http.post('https://short.emitto.io/create', params);
                    //console.log('shortening response: ', response);
                    let shortCode = response.data.replace(this.state.selectedDomain, '')

                    await this.setState({
                        campaignStep: 2,
                        shortenedUrl: response.data,
                        shortCode: shortCode.replace('t/', ''),
                        loading: false
                    });

                    this.getLinkData()

                } catch (e) {
                    // console.log('shorten link response error')

                    // event.preventDefault();
                    //console.log(e)
                    toastr.error('Something went wrong... Please try again.');
                    this.setState({
                        loading: false
                    })
                }

                //decrease freeMessages

                try {
                    // console.log('decrease call: ', '/api/user/' + this.props.user.id + '/project/' + this.state.selectedSource + '/decrease_url')

                    const decreaseResponse = await http.patch('/api/user/' + this.props.user.id + '/project/' + this.state.selectedSource + '/decrease_url', {}, {
                        headers: {
                            authorization: getJwt()
                        }
                    });

                    // console.log('decreaseResponse: ', decreaseResponse)
                    //console.log('remainingMessages: ', decreaseResponse.data.free_messages_remaining);
                    this.setState({
                        freeMessages: decreaseResponse.data.free_messages_remaining
                    })
                } catch (e) {
                    // console.log('decrease error')

                    //console.log(e)
                    toastr.error('Something went wrong... Please try again.');
                    this.setState({
                        loading: false
                    })
                }
            } else {
                toastr.error("URL field can't be empty.")
            }
        } else {
            this.openUpgradeModal()
        }
    };


    openCustomizeShortCodeModal = () => {
        this.setState({customizeShortLinkModal: true})
    }

    getLinkData = async () => {
        //console.log('enters getLinkData');
        const API_META = "/api/url_metadata";

        let URL_META = this.state.longUrl;
        let n = URL_META.startsWith('http');

        if (n === false) {
            URL_META = 'http://' + URL_META;
            this.setState({longUrl: URL_META});
        }
        try {
            this.setState({loadingPreview: true})
            const result = await http.post(API_META, {
                'url': URL_META
            })
            //console.log('get link data result: ', result);

            await this.setState({
                previewImgUrl: result.data.image, previewTitle: result.data.title, loadingPreview: false
            })

        } catch (e) {
            this.setState({
                loadingPreview: false
            });
            this.setState({linkUnavailable: true})
        }
    };

    editShortenedLink = () => {
        this.setState({
            campaignStep: 1
        })

    };
    cancelEditing = () => {
        this.setState({
            campaignStep: 2
        })
    }
    shortenNew = () => {
        this.setState({
            campaignStep: 1, longUrl: '', title: '', longUrlUtm: '', shortenedUrl: ''
        })
    };
    toggleNavigation = async (e) => {
        await this.setState({
            navigation: e
        })
        this.props.history.push(e === 1 ? '/url/shortener' : e === 2 ? '/url/analytics' : '/url/settings')
    };
    copyToClipboard = () => {
        //console.log('shortenedURL: ', document.querySelector('#shortenedUrl').value);
        const myInp = document.getElementById('shortenedUrl');
        const btnCopy = document.getElementById('copy');
        myInp.select();
        document.execCommand('Copy')
        this.setState({
            clipboard: 1
        })
    }

    render() {

        if (this.props.selectedSource !== ''
            //    || this.props.feedsShared.length
        ) {


            return (<React.Fragment>
                    <h1 className='main-title'>Shorten URL</h1>

                    {/*<p className="nav-back" onClick={() => this.props.history.push('campaigns')}><i*/}
                    {/*    className="fas fa-chevron-left"></i> New Campaign</p>*/}

                    <div className='tabs-navigation'>
                        <div
                            onClick={e => this.toggleNavigation(1)}
                            className={this.state.navigation === 1 ? "navigation-tab active" : 'navigation-tab'}
                            id='shorten-url'>
                            <span className="fas fa-link"></span>
                            Shorten URL

                        </div>
                        <div
                            onClick={e => this.toggleNavigation(2)}
                            className={this.state.navigation === 2 ? "navigation-tab active" : 'navigation-tab'}>
                            <span className="fas fa-chart-bar"></span>
                            Analytics
                        </div>
                        <div
                            onClick={e => this.toggleNavigation(3)}
                            className={this.state.navigation === 3 ? "navigation-tab active" : 'navigation-tab'}>
                            <span className="fas fa-cog"></span>
                            Settings
                        </div>
                    </div>
                    <Switch>
                        <Route
                            path='/url/shortener'
                            render={(props) => <div
                                className="fb-message-wrapper url-shortener-wrapper panel-container">
                                <div className="flex-row-wrapper">
                                    <div className="full-row-label text-bold m-m-b uppercase">
                                        URL Shortener
                                    </div>

                                    <div className="half-width">
                                        {this.state.campaignStep === 1 ? <React.Fragment>
                                            <div className="form-group m-m-b primary-text">
                                                <label className='full-row-label'>Base URL</label>
                                                <textarea autoFocus={true} id='longUrl'
                                                          onChange={(e) => this.handleInput(e)}
                                                          className='post-message-text'
                                                          placeholder='Enter the link you’d like to shorten'
                                                          rows={2}
                                                          value={this.state.longUrl}

                                                />
                                            </div>
                                            <div className="form-group m-m-b">
                                                <label className='full-row-label'>Title</label>
                                                <input id='title'
                                                       placeholder='Add title for easier differentiation between links'
                                                       onChange={(e) => this.handleInput(e)}
                                                       className='fb-sponsored-message-input'
                                                       type="text"
                                                       value={this.state.title}
                                                />
                                            </div>

                                            <div className="form-group m-m-b primary-text">
                                                <label className='full-row-label'>UTM Tagged URL</label>
                                                <textarea id='longUrlUtm' readOnly={true} rows="5"
                                                          className='post-message-text disabled'
                                                          value={this.state.longUrlUtm}/>


                                            </div>

                                            <div className="shortener-buttons">
                                                {this.state.shortenedUrl === '' ? <button
                                                    onClick={this.state.freeMessages === 0 ? this.noMessagesRemaining : this.generateShortURL}
                                                    className='btn-lg btn-action'
                                                    disabled={this.state.loading ? true : ''}
                                                >
                                                    Generate Short URL
                                                    {this.state.loading ?
                                                        <i className='fa fa-spin fa-spinner'></i> : ""}
                                                </button> : <React.Fragment>
                                                    <button onClick={this.cancelEditing}
                                                            className=' btn-lite clipboard'>Cancel
                                                    </button>

                                                    <button onClick={this.saveEditData} id='copy'
                                                            disabled={this.state.loading ? true : ''}
                                                            className=' btn-action clipboard'>Save Changes
                                                        {this.state.loading ?
                                                            <i className='fa fa-spin fa-spinner'></i> : ""}

                                                    </button>
                                                </React.Fragment>}
                                            </div>
                                        </React.Fragment> : <div className='short-link-container'>
                                            <div className="form-group m-m-b">
                                                <label
                                                    className='full-row-label display-flex justify-content-space'><span>Shortened
                                                            Website URL</span>
                                                    <p
                                                        onClick={this.openCustomizeShortCodeModal}
                                                        className='save-utm'>Customize Short Link</p></label>
                                                <input readOnly={true} id='shortenedUrl'
                                                       value={this.state.shortenedUrl}
                                                       onChange={(e) => this.handleInput(e)}
                                                       className='fb-sponsored-message-input'
                                                       type="text"/>
                                            </div>
                                            <div className='shortener-buttons'>
                                                <button onClick={this.editShortenedLink}
                                                        className=' btn-lite clipboard btn-sm'>Edit
                                                </button>

                                                <button onClick={this.copyToClipboard} id='copy'
                                                        className=' btn-action clipboard btn-sm'>
                                                    Copy to Clipboard
                                                </button>
                                            </div>
                                            {this.state.clipboard === 1 ? <Callout intent={Intent.SUCCESS}>

                                                Link copied to Clipboard
                                            </Callout> : ''}
                                            <div className="form-group social-container m-m-b">
                                                <label className="full-row-label text-bold m-m-t">Share your
                                                    shortened
                                                    link
                                                    :</label>
                                                <FacebookShareButton url={this.state.shortenedUrl}>
                                                    <FacebookIcon size={32} round={true}/>
                                                </FacebookShareButton>

                                                <TwitterShareButton url={this.state.shortenedUrl}>
                                                    <TwitterIcon size={32} round={true}/>
                                                </TwitterShareButton>
                                                <LinkedinShareButton url={this.state.shortenedUrl}>
                                                    <LinkedinIcon size={32} round={true}/>
                                                </LinkedinShareButton>
                                                <VKShareButton url={this.state.shortenedUrl}>
                                                    <VKIcon size={32} round={true}/>
                                                </VKShareButton>
                                                <RedditShareButton url={this.state.shortenedUrl}>
                                                    <RedditIcon size={32} round={true}/>
                                                </RedditShareButton>
                                            </div>
                                            <div className="shortener-buttons">
                                                <button onClick={this.shortenNew}
                                                        className=' btn-action clipboard btn-lg'>Shorten new
                                                    link
                                                </button>
                                            </div>
                                        </div>

                                        }


                                    </div>
                                    <div className='half-width'>

                                        {this.state.campaignStep === 1 ? <React.Fragment>


                                            <BlueprintSwitch
                                                checked={this.state.utmTracking}
                                                label="UTM Tracking Code Builder"
                                                onClick={this.toggleEnableUTM}
                                                onChange={this.switchOnChange}
                                            />

                                            {this.state.utmTracking === true ?

                                                <React.Fragment>
                                                    {this.state.currentPlanLimitations ? this.state.currentPlanLimitations.url_shortener ? this.state.currentPlanLimitations.url_shortener.utm_tag === 0 ?
                                                        <Callout
                                                            intent='primary'
                                                            icon='info-sign'
                                                        >
                                                            UTM Tracking is not available on your current
                                                            plan. In order to unlock this
                                                            feature <a
                                                            href="#"
                                                            onClick={this.utmTagsUnavailableUpsellModal}>Upgrade
                                                            Now.</a>
                                                        </Callout> : '' : '' : ''

                                                    }

                                                    <div className="form-group m-m-b">
                                                        <label className='full-row-label'>Campaign Name</label>
                                                        <input id='utmCampaign'
                                                               value={this.state.utmCampaign}
                                                               onChange={(e) => this.handleInput(e)}
                                                               placeholder='ex. Emitto'
                                                               className='fb-sponsored-message-input'
                                                               type="text"/>
                                                    </div>
                                                    <div className="form-group m-m-b">
                                                        <label className='full-row-label'>Campaign Source</label>
                                                        <input id='utmSource' value={this.state.utmSource}
                                                               onChange={(e) => this.handleInput(e)}
                                                               placeholder='ex. Marketing'
                                                               className='fb-sponsored-message-input'
                                                               type="text"/>
                                                    </div>
                                                    <div className="form-group m-m-b">
                                                        <label className='full-row-label'>Campaign Medium</label>
                                                        <input id='utmMedium' placeholder='ex. facebook'
                                                               value={this.state.utmMedium}
                                                               onChange={(e) => this.handleInput(e)}
                                                               className='fb-sponsored-message-input'
                                                               type="text"/>
                                                    </div>
                                                    <div className="form-group m-m-b">
                                                        <label className='full-row-label'>Campaign Term</label>
                                                        <input id='utmTerm'
                                                               placeholder='(optional) used for paid keywords'
                                                               onChange={(e) => this.handleInput(e)}
                                                               value={this.state.utmTerm}
                                                               className='fb-sponsored-message-input' type="text"/>
                                                    </div>
                                                    <div className="form-group m-m-b">
                                                        <label className='full-row-label'>Campaign Content</label>
                                                        <input id='utmContent' value={this.state.utmContent}
                                                               placeholder='(optional) used to differentiate ads'
                                                               onChange={(e) => this.handleInput(e)}
                                                               className='fb-sponsored-message-input' type="text"/>
                                                    </div>
                                                    <div className="form-group m-m-b">
                                                        <label className='full-row-label'>Custom Campaign
                                                            Parameter</label>
                                                        <div className='flex-row-wrapper'>
                                                            <div className="half-width">
                                                                <input id='customName' value={this.state.customName}
                                                                       placeholder='Add name'
                                                                       onChange={(e) => this.handleInput(e)}
                                                                       className='fb-sponsored-message-input'
                                                                       type="text"/>
                                                            </div>
                                                            <div className="half-width">
                                                                <input id='customValue'
                                                                       value={this.state.customValue}
                                                                       placeholder='Add value'
                                                                       onChange={(e) => this.handleInput(e)}
                                                                       className='fb-sponsored-message-input'
                                                                       type="text"/>
                                                            </div>
                                                        </div>

                                                    </div>

                                                    {/*<div className="m-sm-b"><label className=" checkbox">*/}
                                                    {/*    Remember these entries as default UTM settings*/}
                                                    {/*    <input onClick={this.handleRemember} title="Send to all"*/}
                                                    {/*           checked={this.state.remember} type="checkbox"/>*/}
                                                    {/*    <span className="checkmark"/></label>*/}
                                                    {/*</div>*/}


                                                </React.Fragment>

                                                :

                                                ''}

                                            <p className='save-utm' onClick={this.handleRemember}>
                                                Save this setting as my default UTM settings
                                            </p>

                                        </React.Fragment> : <React.Fragment>
                                            <div className='full-row-label'>Preview</div>

                                            <div className="preview-screen text-center">
                                                {this.state.linkUnavailable ? <p className='unavailable-link'>
                                                        The preview for this link is unavailable.
                                                    </p>

                                                    : this.state.loadingPreview === true ?
                                                        <img src="/img/simple-loader.svg" alt="loader"/> :

                                                        <div className="preview-post">
                                                            <div className="preview-post-picture post-picture-style"
                                                                 style={{backgroundImage: 'url(' + this.state.previewImgUrl + ')'}}
                                                            >
                                                            </div>
                                                            <div className="preview-post-title text-left">
                                                                {this.state.previewTitle}
                                                            </div>

                                                        </div>

                                                }
                                            </div>

                                        </React.Fragment>}

                                    </div>


                                </div>
                            </div>}
                        />
                        <Route
                            path='/url/analytics'
                            render={(props) => <URLShortenerPerformance
                                {...this.props}
                                selectedSource={this.props.selectedSource}
                                history={this.props.history}
                                editShortenedUrl={this.editShortenedUrl}
                                isodateToDate={this.props.isodateToDate}
                            />}
                        />
                        <Route path="/url/settings"
                               render={(props) => <div
                                   className="fb-message-wrapper url-shortener-wrapper panel-container">
                                   <div className="flex-row-wrapper">
                                       <div className="full-row-label shortener-settings text-bold m-m-b uppercase">
                                           URL Shortener Settings
                                           <p>Shortener Domains</p>
                                           {this.state.selectedDomain === 'https://s.emitto.io/t/' ?
                                               <label className='radio-container'
                                                      onClick={e => this.handleDomainRadio('https://s.emitto.io/t/')}
                                                      htmlFor="emitto">
                                                   s.emitto.io
                                                   <input checked
                                                          onClick={e => this.handleDomainRadio('https://s.emitto.io/t/')}
                                                          type="radio" id='emitto' name='domain-option'/>
                                                   <span className='checkmark'></span>

                                               </label> :
                                               <label onClick={e => this.handleDomainRadio('https://s.emitto.io/t/')}
                                                      htmlFor="emitto" className='radio-container'>
                                                   s.emitto.io
                                                   <input
                                                       onClick={e => this.handleDomainRadio('https://s.emitto.io/t/')}
                                                       type="radio" id='emitto' name='domain-option'/>
                                                   <span className='checkmark'></span>

                                               </label>}
                                           {this.state.selectedDomain === 'https://oo.fyi/t/' ?
                                               <label className='radio-container'
                                                      onClick={e => this.handleDomainRadio('https://oo.fyi/t/')}
                                                      htmlFor="oo"
                                               >oo.fyi
                                                   <input checked
                                                          onClick={e => this.handleDomainRadio('https://oo.fyi/t/')}
                                                          type="radio" id='oo' name='domain-option'/>
                                                   <span className='checkmark'></span>
                                               </label> :
                                               <label onClick={e => this.handleDomainRadio('https://oo.fyi/t/')}
                                                      htmlFor="oo" className='radio-container'>oo.fyi
                                                   <input onClick={e => this.handleDomainRadio('https://oo.fyi/t/')}
                                                          type="radio" id='oo' name='domain-option'/>
                                                   <span className='checkmark'></span>

                                               </label>

                                           }

                                           <Tooltip content="Coming Soon!" position={Position.BOTTOM}
                                                    interactionKind={PopoverInteractionKind.HOVER}>
                                               <button disabled id='add-custom-domain' className='btn-action'>Add Custom
                                                   Domain
                                               </button>
                                           </Tooltip>
                                       </div>
                                   </div>
                               </div>}/>
                    </Switch>
                    <CustomizeShortLinkModal
                        showModal={this.state.customizeShortLinkModal}
                        handleClose={() => this.setState({customizeShortLinkModal: false})}
                        maxWidth={540}
                        history={this.props.history}
                        shortCode={this.state.shortCode}
                        saveShortCode={this.saveShortCode}
                        selectedDomain={this.state.selectedDomain}
                        oldShortCode={this.state.shortCode}

                    />
                    <UpsellModalTailwind
                        showModal={this.state.upgradeModalActive}
                        handleClose={() => this.setState({upgradeModalActive: false})}
                        maxWidth={null}
                        history={this.props.history}
                        title={this.state.upgradeModalTitle}
                        content={this.state.upgradeModalContent}
                        plan={this.state.sourcePlan}
                        user={this.props.user}
                        selectedSource={this.state.selectedSource}
                    />
                </React.Fragment>)
        } else {
            return (<React.Fragment>
                    <h1 className='main-title'>Shorten URL</h1>
                    <div className="row">
                        <div className="col-xs-12 text-center no-feeds-containers">
                            <div className="feed-msg">
                                <img className='emitto-mark' src="/img/emitto-mark.png" alt="Emitto Mark"/>
                                <p className="text-center ">{authService.getCurrentUserName()}</p>
                                <p>It looks like you haven't set up any workspaces yet. Add your first workspace, and
                                    start
                                    growing your audience.</p>
                                <img className='cat-img' src="/img/cat-transparent.gif" alt="No Workspaces"/>
                            </div>
                            <button className='btn-m btn-action' onClick={this.props.addSource} type="button">
                                Create your first workspace
                            </button>
                        </div>

                    </div>
                </React.Fragment>)
        }

    }
}

export default UrlShortener;